module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "label": "Parcel Number Container",
      "items": _vm.parcelnumbercontainers,
      "item-value": "id"
    },
    on: {
      "change": function($event) {
        return _vm.saveParcelNumberContainer()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', [_vm._v(_vm._s(_vm.getChipString(data.item)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.name))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-chip', [_vm._v(_vm._s(_vm.getChipString(data.item)))]), _vm._v(" " + _vm._s(data.item.name) + "\n  ")]
      }
    }]),
    model: {
      value: (_vm.dirtyParcelNumberContainerId),
      callback: function($$v) {
        _vm.dirtyParcelNumberContainerId = $$v
      },
      expression: "dirtyParcelNumberContainerId"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/template-compiler?{"id":"data-v-75d81662"}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/selector.js?type=template&index=0!./client/components/IsrsParcelNumberSelect.vue
// module id = 944
// module chunks = 1